import { LegalLayout, LegalSection } from "@/components/uc/LegalLayout";

const INVENTORY = [
  ["Google (Gmail)", "Email address, app password (encrypted at rest), scanned message metadata you authorize", "Inbox monitoring, outbound email dispatch"],
  ["Stripe", "Tokenized payment methods, transaction records — raw card numbers never touch our servers", "Command Wallet payments and charges"],
  ["Pinecone", "Vector embeddings of memory entries (no raw credentials)", "Semantic search across System Memory"],
  ["Mapbox", "Coarse location context for venture mapping features, if enabled", "Geographic visualization"],
  ["Anthropic / OpenAI", "Prompts and context you submit to AI features", "Insights, drafts, campaigns, support answers"],
  ["Twilio", "Your phone number and alert message contents", "SMS alerts"],
];

export default function Privacy() {
  return (
    <LegalLayout eyebrow="LEGAL ARMOR" title="Privacy Policy" testId="privacy-page">
      <p className="text-white/50 font-mono-uc text-[11px] uppercase tracking-wider">Effective: February 2026 · THE SOVEREIGN UMBRELLA COMMAND</p>

      <LegalSection n="1" heading="What We Hold">
        <p>Account identity (email, hashed password), your venture records, agent insights and drafts, vault documents (encrypted with Fernet symmetric encryption — we cannot read sealed content without your session), execution logs, and support conversations. Authentication uses secure httpOnly cookies; we never store session tokens in browser storage.</p>
      </LegalSection>

      <LegalSection n="2" heading="Data Inventory — Sub-processors">
        <div className="border border-white/10 overflow-x-auto" data-testid="data-inventory-table">
          <table className="w-full text-left text-xs">
            <thead>
              <tr className="border-b border-white/10 font-mono-uc text-[10px] uppercase tracking-wider text-white/40">
                <th className="p-3">Processor</th><th className="p-3">Data Shared</th><th className="p-3">Purpose</th>
              </tr>
            </thead>
            <tbody>
              {INVENTORY.map(([name, data, purpose]) => (
                <tr key={name} className="border-b border-white/5">
                  <td className="p-3 text-amber-400 whitespace-nowrap">{name}</td>
                  <td className="p-3 text-white/70">{data}</td>
                  <td className="p-3 text-white/50">{purpose}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </LegalSection>

      <LegalSection n="3" heading="Cookies">
        <p>We use one strictly-necessary cookie (<span className="font-mono-uc text-amber-400">uc_session</span>, httpOnly, secure) for authentication, and a consent-preference entry in local storage. We do not run advertising or cross-site tracking cookies. The cookie banner records your choice.</p>
      </LegalSection>

      <LegalSection n="4" heading="Your Rights — Right to be Forgotten">
        <p><strong className="text-white">Download My Data</strong>: Settings → Data & Privacy exports a complete JSON archive of everything we hold about you. <strong className="text-white">Delete My Account</strong>: permanently erases your account and cascades deletion across every collection — ventures, insights, drafts, tasks, vault records, payment references, memory, logs, and support chats. Deletion is immediate and irreversible.</p>
      </LegalSection>

      <LegalSection n="5" heading="Retention & Security">
        <p>Data persists until you delete it. Vault content is encrypted at rest; passwords are hashed with bcrypt; financial actions are double-gated behind explicit approval. See our <a href="/security" className="text-amber-400 hover:underline">Security Statement</a> for infrastructure detail.</p>
      </LegalSection>

      <LegalSection n="6" heading="SMS / Mobile Alerts">
        <p data-testid="privacy-sms-clause">If you opt in to SMS alerts by entering your mobile number in Settings, we use Twilio to deliver operational alert messages (e.g., submission confirmations, bridge status changes, critical account notifications). <strong className="text-white">No mobile information will be shared with third parties or affiliates for marketing or promotional purposes.</strong> Text messaging originator opt-in data and consent will not be sold, rented, or shared with any third party. Message frequency varies based on your account activity. Message and data rates may apply. You can opt out at any time by replying <span className="font-mono-uc text-amber-400">STOP</span> to any message or by clearing your phone number in Settings. Reply <span className="font-mono-uc text-amber-400">HELP</span> for help.</p>
      </LegalSection>

      <LegalSection n="7" heading="Contact">
        <p>Privacy requests: <span className="text-amber-400">privacy@umbrellacommand.example</span>. We respond within 30 days.</p>
      </LegalSection>
    </LegalLayout>
  );
}
